"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7720],{

/***/ 21693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_link; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
;// CONCATENATED MODULE: ./components/atoms/link/Link.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        u-actions pb-1 aria-disabled:pointer-events-none aria-disabled:text-primary-200 hover:cursor-pointer\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var LinkAbstract = function(_param, ref) {
    var as = _param.as, _type = _param.type, type = _type === void 0 ? "primary" : _type, _size = _param.size, size = _size === void 0 ? "small" : _size, _className = _param.className, className = _className === void 0 ? "" : _className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "as",
        "type",
        "size",
        "className",
        "children"
    ]);
    var HTMLTag = as || "a";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,es/* oneLine */.f9)(_templateObject(), type === "primary" ? "text-primary-900  hover:text-primary-600" : "", type === "secondary" ? "text-secondary-500 hover:text-secondary-600" : "", type === "alternative" ? "text-typo-alternative hover:text-primary-900" : "", type === "current-color" ? "text-current hover:text-current" : "", type === "primary" || type === "alternative" ? "underline underline-offset-4" : "", size === "body" ? "u-body u-body--xs normal-case" : "", size === "small" ? "u-actions u-actions--link" : "", size === "large" ? "u-actions u-actions--link-large" : "", className)
    }, props), {
        children: children
    }));
};
var Link = /*#__PURE__*/ (0,react.forwardRef)(LinkAbstract);

;// CONCATENATED MODULE: ./components/atoms/link/index.ts

/* harmony default export */ var atoms_link = (Link);


/***/ }),

/***/ 21393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ notifications; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
;// CONCATENATED MODULE: ./components/atoms/notifications/Notifications.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      u-body flex flex-row items-start justify-start gap-2\n      ",
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StylesByStateBox = {
    OK: "bg-[#e7f1da]",
    ERROR: "bg-[#FFE8E8]",
    INFO: "bg-primary-100"
};
var StylesByStateText = {
    OK: "text-status-success",
    ERROR: "text-status-error",
    INFO: "text-primary-900"
};
/**
 * Notifications
 */ var Notifications = function(param) {
    var message = param.message, state = param.state, Icon = param.Icon, _box = param.box, box = _box === void 0 ? true : _box, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,es/* oneLine */.f9)(_templateObject(), box ? "u-body--s p-2 ".concat(StylesByStateBox[state]) : "u-body--xs", StylesByStateText[state], className),
        children: [
            Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                width: 19,
                height: 19,
                className: "shrink-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: message
            })
        ]
    });
};
Notifications.displayName = "Notifications";

;// CONCATENATED MODULE: ./components/atoms/notifications/index.ts

/* harmony default export */ var notifications = (Notifications);


/***/ }),

/***/ 3957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ card_add_product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/assets/images/bottle-add-product.svg
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBottleAddProduct = function SvgBottleAddProduct(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 58 195",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M27.666 117.667v-8h2.667v8h8v2.666h-8v8h-2.666v-8h-8v-2.666h8Z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m19.622 21.508-1.988-.21c-.145 1.36-.288 2.721-.432 4.082l1.989.21.431-4.082Zm-.863 8.165-1.99-.21-.432 4.081 1.989.211.433-4.082Zm-.868 8.165-1.988-.213-.438 4.08 1.988.215.438-4.082ZM17.011 46l-1.988-.216c-.148 1.36-.297 2.719-.447 4.078l1.988.219c.15-1.36.3-2.72.448-4.081Zm-.9 8.161-1.987-.222c-.152 1.358-.306 2.717-.46 4.075l1.987.227c.155-1.36.308-2.72.46-4.08Zm-.93 8.158-1.986-.23-.237 2.036v.002c-.058.49-.169.996-.327 1.528l1.916.572c.184-.618.324-1.24.397-1.87.08-.679.16-1.358.238-2.038Zm-2.052 7.457-1.82-.831-.12.265a74.555 74.555 0 0 0-.682 1.516l-.003.008c-.11.256-.246.52-.41.804l1.731 1.001a9.5 9.5 0 0 0 .518-1.02 76.716 76.716 0 0 1 .786-1.743Zm-2.52 4.701-1.705-1.045c-.219.356-.443.744-.648 1.16a57.593 57.593 0 0 0-.793 1.679l1.822.825c.246-.542.5-1.082.766-1.62.168-.342.358-.673.558-.999Zm-2.697 5.93-1.871-.706a58.603 58.603 0 0 0-1.2 3.511l1.912.587c.35-1.139.735-2.27 1.159-3.392Zm-2.103 6.85-1.945-.468a63.067 63.067 0 0 0-.76 3.622l1.97.354a61.04 61.04 0 0 1 .735-3.508Zm-1.27 7.052-1.985-.243a71.26 71.26 0 0 0-.353 3.67l1.995.141c.084-1.196.198-2.385.343-3.568Zm-.508 7.149-2-.045a86.4 86.4 0 0 0-.02 1.837v1.951h2v-1.951c0-.599.007-1.196.02-1.792Zm-.02 7.646h-2v3.902h2v-3.902Zm0 7.804h-2v3.903h2v-3.903Zm-.001 7.805h-2v3.902l2 .001v-3.903Zm-.001 7.805h-2v3.902h2v-3.902Zm-.001 7.805-2-.001v3.903h2v-3.902Zm-.001 7.804h-2l-.001 3.902 2 .001v-3.903Zm-.002 7.805h-2v3.902l2 .001v-3.903Zm-.001 7.805h-2l-.001 3.902h2v-3.902Zm-.002 7.805-2-.001v3.903h2v-3.902ZM4 179.347H2v1.951c0 .745.04 1.465.121 2.157l1.986-.235A16.387 16.387 0 0 1 4 181.299v-1.952Zm1.19 7.54-1.761.947a9.014 9.014 0 0 0 3.353 3.522l1.026-1.717a7.012 7.012 0 0 1-2.618-2.752Zm6.247 3.942-.265 1.982a16.92 16.92 0 0 0 2.174.145l2.003.01.01-2-2.002-.01a15.115 15.115 0 0 1-1.92-.127Zm7.924.153-.007 2c1.335.005 2.67.008 4.006.011l.004-2c-1.334-.003-2.669-.006-4.003-.011Zm8.006.017-.002 2 4.006.001-.001-2-4.003-.001Zm8.006-.005.003 2c1.336-.002 2.67-.006 4.006-.01l-.007-2c-1.334.004-2.668.008-4.002.01Zm8.005-.027.01 2 2.003-.011a16.876 16.876 0 0 0 2.24-.158l-.28-1.981c-.62.088-1.278.135-1.972.139l-2.001.011Zm7.69-1.415 1.044 1.705a9.42 9.42 0 0 0 3.393-3.593l-1.758-.953a7.43 7.43 0 0 1-2.68 2.841Zm3.813-6.604 1.985.243c.087-.711.13-1.451.13-2.217V178.9l-2-.001v2.075c0 .692-.039 1.35-.115 1.974Zm.116-8.198h2v-4.149l-2-.001v4.15Zm.002-8.299h2v-4.149l-2-.001v4.15Zm0-8.299h2v-4.149h-2v4.149Zm.001-8.299h2v-4.15l-2 .001v4.149Zm0-8.299h2l-.001-4.15-2 .001v4.149Zm-.003-8.299h2l-.001-4.15-2 .001.001 4.149Zm-.003-8.299 2-.001-.002-4.149-2 .001.002 4.149Zm-.005-8.299 2-.001-.004-4.15-2 .002.004 4.149Zm-.008-8.299 2-.002-.002-2.074v-.002l-.001-.746c0-.59-.001-1.184-.004-1.776l-2 .009a518.62 518.62 0 0 1 .005 2.517l.002 2.074Zm-.123-9.624 1.997-.102a58.561 58.561 0 0 0-.188-2.6 81.756 81.756 0 0 0-.255-2.307l-1.985.248c.093.746.176 1.497.249 2.25.08.835.139 1.672.182 2.511Zm-2.14-13.649 1.931-.518a63.295 63.295 0 0 1 1.041 4.558l-1.965.374a61.296 61.296 0 0 0-1.008-4.414Zm-1.352-4.321 1.882-.677a52.04 52.04 0 0 0-1.79-4.355l-1.813.844a50.073 50.073 0 0 1 1.721 4.188Zm-3.824-8.197 1.725-1.012a49.062 49.062 0 0 0-1.148-1.86c-.232-.538-.444-1.017-.635-1.448l-.01-.024-1.83.809.01.022c.21.473.441.996.695 1.588.416.636.814 1.278 1.194 1.925ZM44.37 65.76l1.93-.526a9.103 9.103 0 0 1-.265-1.42l-.217-1.977-1.989.218.218 1.98a11.1 11.1 0 0 0 .323 1.725Zm-.97-7.665 1.989-.214c-.142-1.319-.283-2.638-.422-3.957l-1.99.21c.14 1.32.281 2.641.423 3.961Zm-.839-7.922 1.99-.207-.412-3.96-1.99.206.412 3.961Zm-.819-7.923 1.99-.204-.404-3.96-1.99.201.404 3.963Zm-.805-7.925 1.99-.202-.4-3.962-1.99.2.4 3.964Zm-.8-7.926 1.99-.2-.399-3.964-1.99.201.4 3.963Zm-2.26-21.805.784-1.84a7.48 7.48 0 0 0-2.517-.568h-.001c-.55-.032-1.101-.059-1.653-.082l-.084 1.998c.541.023 1.082.05 1.623.08.69.04 1.305.18 1.848.412Zm-6.72-.583.027-2a117.885 117.885 0 0 0-3.306.001l.029 2c1.083-.016 2.167-.016 3.25-.001Zm-6.5.092-.083-1.998c-.55.023-1.1.05-1.65.08m1.734 1.918c-.542.023-1.083.05-1.623.08a5.09 5.09 0 0 0-1.812.423l-.818-1.825a7.092 7.092 0 0 1 2.52-.595",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M18.744 7.581a6.133 6.133 0 0 0-.218 1.587l2.326.319-.012.005-.023.245-.115 1.229-.053-.005-.07.507-4.07-.558.017-1.762a8.018 8.018 0 0 1 .397-2.45l1.898.63a5.296 5.296 0 0 0-.077.253Zm21.833 0c.138.495.212 1.028.218 1.587l-2.326.319.011.005.023.245c.04.412.078.822.116 1.229l.052-.005.07.507 4.071-.558-.018-1.762a8.015 8.015 0 0 0-.396-2.45l-1.898.63c.027.084.053.168.077.253Zm-20.17 6.345-1.972-.207-.375 3.487 1.992.228.355-3.508Zm20.813 3.301-1.972.207-.375-3.487 1.992-.228.355 3.508Z"
  })));
};
/* harmony default export */ var bottle_add_product = (SvgBottleAddProduct);
;// CONCATENATED MODULE: ./components/molecules/card-add-product/CardAddProduct.tsx






/**
 * CardAddProduct
 */ var Basic = function(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _height = _param.height, height = _height === void 0 ? "195" : _height, _width = _param.width, width = _width === void 0 ? "58" : _width, as = _param.as, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "height",
        "width",
        "as"
    ]);
    var HTMLTag = as || "button";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: "group grid place-items-center bg-bg-secondary p-4 outline outline-1 outline-primary-200 ".concat(className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bottle_add_product, {
            height: height,
            width: width,
            className: "text-primary-400 transition-transform group-hover:scale-105"
        })
    }));
};
Basic.displayName = "CardAddProduct";
var CardAddProduct = /*#__PURE__*/ (0,react.forwardRef)(Basic);

;// CONCATENATED MODULE: ./components/molecules/card-add-product/index.ts

/* harmony default export */ var card_add_product = (CardAddProduct);


/***/ }),

/***/ 11399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ view_more; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(33068);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(21693);
;// CONCATENATED MODULE: ./components/molecules/view-more/ViewMore.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "relative max-h-[3000px] overflow-hidden transition-all ",
        "\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "flex max-w-max cursor-pointer flex-row items-center gap-1 pt-2 ",
        "\n        ",
        " \n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





// TODO Añadir mutation observable para cuando cambie el tamaño ocultar el botón o añadirlo
// @see https://blog.logrocket.com/guide-to-custom-react-hooks-with-mutationobserver/
// TODO Animar la entrada del linear gradient para que no se aplique de sopeton
// TODO Hacer que el max-height cuando crezca sea dinámico no de 3000px
/**
 * ViewMore
 */ var ViewMore = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _style = param.style, style = _style === void 0 ? "normal" : _style, _icon = param.icon, icon = _icon === void 0 ? false : _icon, _open = param.open, open = _open === void 0 ? false : _open, _onlySmallDevices = param.onlySmallDevices, onlySmallDevices = _onlySmallDevices === void 0 ? false : _onlySmallDevices, _labels = param.labels, labels = _labels === void 0 ? {
        viewLess: "Ver menos",
        viewMore: "Ver m\xe1s"
    } : _labels, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? 400 : _maxHeight, children = param.children;
    var ref = (0,react.useState)(open), isOpen = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), isAlwaysOpen = ref1[0], setAlwaysOpen = ref1[1];
    var toggle = function(state) {
        return setOpen(state);
    };
    var viewMore = (0,react.useRef)(null);
    var content = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var open = function() {
            setOpen(true);
            setAlwaysOpen(true);
        };
        var close = function() {
            setOpen(false);
            setAlwaysOpen(false);
        };
        // TODO check types
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var noMinimumContent = function() {
            var ref;
            return ((ref = content.current) === null || ref === void 0 ? void 0 : ref.clientHeight) < maxHeight;
        };
        if (onlySmallDevices) {
            var updateWindowDimensions = function() {
                var largeWidth = window.innerWidth > 640;
                if (noMinimumContent() || onlySmallDevices && largeWidth) open();
                else close();
            };
            updateWindowDimensions();
            return function() {
                return window.removeEventListener("resize", updateWindowDimensions);
            };
        } else {
            if (noMinimumContent()) open();
        }
    }, [
        maxHeight,
        onlySmallDevices
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col ".concat(className),
        ref: viewMore,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,es/* oneLine */.f9)(_templateObject(), isOpen ? "" : "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[150px] after:bg-gradient-to-b after:from-[#f8f7f64d] after:to-[#f7f6f5e6] after:content-['']", style === "link" ? "after:content-none" : ""),
                style: {
                    maxHeight: isOpen ? "none" : maxHeight
                },
                ref: content,
                children: typeof children === "function" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: children(isOpen)
                }) : children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (0,es/* oneLine */.f9)(_templateObject1(), style === "link" ? "m-0 text-secondary-500 hover:text-secondary-600" : "mx-auto", isAlwaysOpen ? "hidden" : ""),
                onClick: function() {
                    return toggle(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                        as: "button",
                        type: style === "link" ? "secondary" : "primary",
                        size: style === "link" ? "body" : "small",
                        onClick: function(e) {
                            return e.preventDefault();
                        },
                        children: isOpen ? labels.viewLess : labels.viewMore
                    }),
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* ChevronDown */._, {
                        width: 24,
                        height: 24,
                        className: "".concat(isOpen ? "-rotate-180" : "")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/molecules/view-more/index.ts

/* harmony default export */ var view_more = (ViewMore);


/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_description; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/icons/Info.tsx
var Info = __webpack_require__(79817);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./components/atoms/notifications/index.ts + 1 modules
var notifications = __webpack_require__(21393);
// EXTERNAL MODULE: ./components/molecules/view-more/index.ts + 1 modules
var view_more = __webpack_require__(11399);
// EXTERNAL MODULE: ./components/molecules/button/index.ts + 1 modules
var molecules_button = __webpack_require__(25634);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/icons/Trash.tsx
var Trash = __webpack_require__(52609);
// EXTERNAL MODULE: ./components/icons/ArrowRightCircleLine.tsx
var ArrowRightCircleLine = __webpack_require__(9939);
// EXTERNAL MODULE: ./components/icons/Reload.tsx
var Reload = __webpack_require__(70719);
// EXTERNAL MODULE: ./components/atoms/box-quantity/index.ts + 1 modules
var box_quantity = __webpack_require__(98622);
// EXTERNAL MODULE: ./components/providers/bundle-provider/BundleError.ts
var BundleError = __webpack_require__(53433);
// EXTERNAL MODULE: ./lib/hooks/useBundleDispatch.ts
var useBundleDispatch = __webpack_require__(5027);
// EXTERNAL MODULE: ./lib/hooks/useBundle.ts
var useBundle = __webpack_require__(50968);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(20457);
// EXTERNAL MODULE: ./components/molecules/slider-product/index.ts + 1 modules
var slider_product = __webpack_require__(56029);
// EXTERNAL MODULE: ./components/molecules/card-product/index.ts + 15 modules
var card_product = __webpack_require__(42654);
// EXTERNAL MODULE: ./components/molecules/card-add-product/index.ts + 2 modules
var card_add_product = __webpack_require__(3957);
;// CONCATENATED MODULE: ./components/molecules/bundle-options/BundleOptions.tsx









var Heading = function(param) {
    var count = param.count, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
        className: "u-subtitle u-subtitle--s flex flex-row gap-2 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "u-label u-label--xs grid h-6 w-6 place-items-center rounded-full bg-primary-900 text-center font-bold not-italic text-white",
                children: count
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col",
                children: children
            })
        ]
    });
};
/**
 * BundleOptions
 */ var BundleOptions = function(param) {
    var onCardAddProduct = param.onCardAddProduct;
    var dispatch = (0,useBundleDispatch/* useBundleDispatch */.F)();
    var bundle = (0,useBundle/* useBundle */.$)();
    if (!dispatch || !bundle) throw new BundleError/* BundleError */.E("BundleCart must be inside a BundleProvider");
    var numProducts = bundle.numProducts, selectedProducts = bundle.selectedProducts, selectedVariant = bundle.selectedVariant, variants = bundle.variants;
    var changeVariant = dispatch.changeVariant, subtract = dispatch.subtract;
    var onClick = function() {
        if (numProducts === 0) {
            (0,helpers/* gtmPush */.De)({
                event: "custom_box",
                action: "create_custom_box"
            });
        }
        onCardAddProduct();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                count: 1,
                className: "mb-3",
                children: "Selecciona un tama\xf1o"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-12 ml-8 flex gap-2",
                children: variants.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(box_quantity/* default */.Z, {
                        variant: item.quantity === selectedVariant.quantity ? "orange" : "gray",
                        onClick: function() {
                            return changeVariant(item);
                        },
                        role: "button",
                        width: 60,
                        children: item.quantity
                    }, item.quantity);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                count: 2,
                className: "mb-4",
                children: [
                    "Selecciona los productos",
                    numProducts === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "u-body u-body--xs normal-case text-typo-secondary",
                        children: "Pulsa sobre las botellas para comenzar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(slider_product/* default */.Z, {
                perPage: 3,
                breakpoints: {
                    1024: {
                        perPage: 3
                    },
                    900: {
                        perPage: 4,
                        padding: 40
                    },
                    768: {
                        padding: 40,
                        perPage: 3
                    },
                    390: {
                        padding: 40,
                        perPage: 2
                    },
                    300: {
                        padding: 40,
                        perPage: 1
                    }
                },
                className: "-mx-4 mb-4 px-4 lg:mx-0 lg:px-0",
                children: (0,_to_consumable_array/* default */.Z)(selectedProducts.map(function(param) {
                    var id = param.id, image = param.image, name = param.name, uri = param.uri, quantity = param.quantity, type = param.type, primaryCategory = param.primaryCategory, price = param.price, regularPrice = param.regularPrice, stockStatus = param.stockStatus;
                    return Array.from(Array(quantity).keys()).map(function(_, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_product/* default */.Z, {
                            productID: id,
                            href: uri,
                            type: type,
                            stock: stockStatus,
                            editable: false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Image */.Z.Image, {
                                    src: image.src,
                                    alt: image.alt
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Category */.Z.Category, {
                                    href: primaryCategory.path,
                                    children: primaryCategory.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Name */.Z.Name, {
                                    children: name
                                }),
                                price && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.PriceDiscounted */.Z.PriceDiscounted, {
                                    children: regularPrice
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "absolute right-3 top-3 z-10 hover:text-primary-600",
                                    onClick: function() {
                                        return subtract(id);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trash/* Trash */.r, {
                                        width: 18
                                    })
                                })
                            ]
                        }, "".concat(id, "-").concat(index));
                    });
                }).flat()).concat((0,_to_consumable_array/* default */.Z)(Array.from(Array(selectedVariant.quantity - numProducts).keys()).map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card_add_product/* default */.Z, {
                        className: "min-h-[312px] w-full",
                        onClick: onClick
                    }, index);
                })))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                variant: numProducts === 0 ? "primary" : "secondary",
                icon: numProducts === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightCircleLine/* ArrowRightCircleLine */.S, {
                    className: "transition-transform group-hover:translate-x-1"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Reload/* Reload */.L, {
                    width: 16,
                    height: 16,
                    className: "transition-transform group-hover:rotate-90"
                }),
                className: "group mb-8 ml-auto !max-w-none sm:!max-w-max",
                onClick: onClick,
                children: numProducts === 0 ? "comenzar" : "Cambiar selecci\xf3n"
            })
        ]
    });
};
BundleOptions.displayName = "BundleOptions";

;// CONCATENATED MODULE: ./components/molecules/bundle-options/index.ts

/* harmony default export */ var bundle_options = (BundleOptions);

// EXTERNAL MODULE: ./lib/routes/index.ts
var routes = __webpack_require__(94696);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
;// CONCATENATED MODULE: ./components/molecules/seller-box/SellerBox.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "u-body u-body--xs flex flex-col gap-y-[2px]\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * SellerBox
 */ var SellerBox = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, seller = param.seller, sellerLink = param.sellerLink, brand = param.brand, deliveryDays = param.deliveryDays, deliveryCosts = param.deliveryCosts, minFreeShipping = param.minFreeShipping, _forceMobile = param.forceMobile, forceMobile = _forceMobile === void 0 ? false : _forceMobile, children = param.children, _alwaysFree = param.alwaysFree, alwaysFree = _alwaysFree === void 0 ? false : _alwaysFree;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "box-border flex flex-col gap-4 border border-dashed border-primary-900 p-3 md:p-4 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "u-body u-body--s flex flex-row items-center gap-1 font-bold",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-primary-900",
                                children: "Vendido y enviado por"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                href: sellerLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-secondary-500",
                                    children: seller.replace("&amp;", "&")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,es/* oneLine */.f9)(_templateObject(), !forceMobile ? "md:flex-row md:divide-x-[1px] md:divide-primary-200 [&>p:nth-child(2)]:md:px-2 first:[&>p]:md:pr-2 last:[&>p]:md:pl-2 only:[&>p]:md:!p-0" : ""),
                        children: [
                            deliveryDays && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Entrega estim: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: deliveryDays
                                    })
                                ]
                            }),
                            deliveryCosts && !alwaysFree && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Gastos de env\xedo: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: deliveryCosts
                                    })
                                ]
                            }),
                            minFreeShipping && !alwaysFree && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Env\xedo gratuito a partir de ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: minFreeShipping
                                    })
                                ]
                            }),
                            alwaysFree && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "Env\xedo gratuito"
                                })
                            })
                        ]
                    }),
                    brand && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "u-body u-body--s flex flex-row items-center gap-1 font-bold",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-primary-900",
                                children: "M\xe1s productos de"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                href: routes.routes.brand(brand.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-secondary-500",
                                    children: brand.title
                                })
                            })
                        ]
                    })
                ]
            }),
            (0,utils/* toArray */.qo)(children).some(Boolean) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-2",
                children: children
            })
        ]
    });
};
SellerBox.displayName = "SellerBox";

;// CONCATENATED MODULE: ./components/molecules/seller-box/index.ts

/* harmony default export */ var seller_box = (SellerBox);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./lib/utils/product.ts
var product = __webpack_require__(60597);
;// CONCATENATED MODULE: ./components/organisms/product/ProductForms.tsx




var BundleVariableProductForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7417), __webpack_require__.e(6310), __webpack_require__.e(2058), __webpack_require__.e(9879), __webpack_require__.e(5051), __webpack_require__.e(7153)]).then(__webpack_require__.bind(__webpack_require__, 22016)).then(function(mod) {
        return mod.BundleVariableProductForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22016)
            ];
        }
    }
});
var SimpleProductForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7417), __webpack_require__.e(6310), __webpack_require__.e(2058), __webpack_require__.e(9879), __webpack_require__.e(5051), __webpack_require__.e(2093)]).then(__webpack_require__.bind(__webpack_require__, 83657)).then(function(mod) {
        return mod.SimpleProductForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83657)
            ];
        }
    }
});
var VariableProductForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7417), __webpack_require__.e(6310), __webpack_require__.e(2058), __webpack_require__.e(9879), __webpack_require__.e(5051), __webpack_require__.e(3986)]).then(__webpack_require__.bind(__webpack_require__, 53383)).then(function(mod) {
        return mod.VariableProductForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53383)
            ];
        }
    }
});
var CustomTagForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7417), __webpack_require__.e(6310), __webpack_require__.e(2058), __webpack_require__.e(9879), __webpack_require__.e(5051), __webpack_require__.e(8093)]).then(__webpack_require__.bind(__webpack_require__, 82520)).then(function(mod) {
        return mod.CustomTagForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82520)
            ];
        }
    }
});
var TEMPLATE_CUSTOM_TAG = "custom-tag";
/**
 * ProductForms
 */ var ProductForms = function(param) {
    var bundledItems = param.bundledItems, woosbIds = param.woosbIds, stock = param.stock, type = param.type, template = param.template, price = param.price, productId = param.productId, regularPrice = param.regularPrice, moreInfo = param.moreInfo, externalUrl = param.externalUrl, isMirakl = param.isMirakl, stockAlert = param.stockAlert, attributes = param.attributes, variations = param.variations, isSellerClosed = param.isSellerClosed;
    var ref, ref1;
    var bundle = (0,useBundle/* useBundle */.$)();
    var showSimpleBoxBuy = type && ((0,product/* isBundle */.w_)(type) && bundle || (0,product/* isSimple */.Gg)(type) || (0,product/* isExternal */.b9)(type) || (0,product/* isBundleWithoutVariables */.YC)(type, {
        bundledItems: bundledItems,
        woosbIds: woosbIds,
        stock: stock
    }));
    var isBundleWithVariablesLayout = type && (0,product/* isBundle */.w_)(type) && !bundle && woosbIds && bundledItems && !showSimpleBoxBuy;
    var isSimpleLayout = showSimpleBoxBuy && (bundle === null || bundle === void 0 ? void 0 : bundle.optionalProducts) && (bundle === null || bundle === void 0 ? void 0 : bundle.numProducts) === (bundle === null || bundle === void 0 ? void 0 : bundle.selectedVariant.quantity) || showSimpleBoxBuy && !bundle;
    var isVariableLayout = type && (0,product/* isVariable */.cG)(type) && template !== TEMPLATE_CUSTOM_TAG;
    var isCustomTagLayout = template === TEMPLATE_CUSTOM_TAG;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isBundleWithVariablesLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(BundleVariableProductForm, {
                productId: productId,
                price: price,
                regularPrice: regularPrice,
                moreInfo: moreInfo,
                stock: stock,
                stockAlert: stockAlert,
                isSellerClosed: isSellerClosed,
                bundledItems: bundledItems,
                woosbIds: woosbIds,
                isMirakl: isMirakl,
                attributes: {
                    edges: (ref = bundledItems === null || bundledItems === void 0 ? void 0 : bundledItems.filter(function(item) {
                        return (0,product/* isVariable */.cG)(item.type);
                    })) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        return item.attributes.edges;
                    }).flat()
                },
                variations: {
                    edges: (ref1 = bundledItems === null || bundledItems === void 0 ? void 0 : bundledItems.filter(function(item) {
                        return (0,product/* isVariable */.cG)(item.type);
                    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                        return item.variations.edges;
                    }).flat()
                }
            }),
            isSimpleLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleProductForm, {
                productId: productId,
                price: (bundle === null || bundle === void 0 ? void 0 : bundle.optionalProducts) ? bundle === null || bundle === void 0 ? void 0 : bundle.totalPrice : price,
                regularPrice: (bundle === null || bundle === void 0 ? void 0 : bundle.optionalProducts) ? bundle === null || bundle === void 0 ? void 0 : bundle.totalRegularPrice : regularPrice,
                moreInfo: moreInfo,
                stock: stock,
                type: type,
                externalUrl: externalUrl,
                stockAlert: stockAlert,
                isSellerClosed: isSellerClosed
            }),
            isVariableLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(VariableProductForm, {
                productId: productId,
                attributes: attributes,
                price: price,
                moreInfo: moreInfo,
                variations: variations,
                stock: stock,
                stockAlert: stockAlert,
                isSellerClosed: isSellerClosed,
                isMirakl: isMirakl
            }),
            isCustomTagLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTagForm, {
                moreInfo: moreInfo,
                productId: productId,
                variations: variations,
                stock: stock,
                stockAlert: stockAlert,
                isSellerClosed: isSellerClosed
            })
        ]
    });
};
ProductForms.displayName = "ProductForms";

;// CONCATENATED MODULE: ./components/organisms/product-description/ProductDescription.tsx



function ProductDescription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                [&>*:not(:last-child,li)]:mb-2\n                [&>ol]:ml-5 [&>ol]:!list-decimal\n                [&>ul]:ml-5 [&>ul]:!list-disc\n                ",
        "\n              "
    ]);
    ProductDescription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    ",
        " \n                    ",
        " \n                    ",
        " €\n                  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








// TODO: Añadir soporte para distintos templates
/**
 * ProductDescription
 */ var ProductDescription = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _category = param.category, category = _category === void 0 ? "" : _category, _categoryLink = param.categoryLink, categoryLink = _categoryLink === void 0 ? "" : _categoryLink, name = param.name, productId = param.productId, _description = param.description, description = _description === void 0 ? "" : _description, price = param.price, regularPrice = param.regularPrice, moreInfo = param.moreInfo, attributes = param.attributes, _type = param.type, type = _type === void 0 ? "simple" : _type, variations = param.variations, _template = param.template, template = _template === void 0 ? "" : _template, stock = param.stock, externalUrl = param.externalUrl, button = param.button, sellerInfo = param.sellerInfo, brand = param.brand, isMirakl = param.isMirakl, estimateDeliveryDate = param.estimateDeliveryDate, _stockAlert = param.stockAlert, stockAlert = _stockAlert === void 0 ? true : _stockAlert, customizableBundleOptions = param.customizableBundleOptions, bundledItems = param.bundledItems, woosbIds = param.woosbIds;
    var dateInterval = "";
    var isSellerClosed = false;
    if ((sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.closedFrom) && sellerInfo.closedTo) {
        var closedFrom = new Date(sellerInfo.closedFrom);
        var closedTo = new Date(sellerInfo.closedTo);
        var now = new Date();
        closedFrom.setDate(closedFrom.getDate() + 1);
        closedTo.setDate(closedTo.getDate() + 1);
        if (now >= closedFrom && now <= closedTo) {
            dateInterval = (0,utils/* formatDateInterval */.wy)(closedFrom, closedTo);
            isSellerClosed = true;
        }
    }
    var _url, ref, _estimateDeliveryDateMin, _estimateDeliveryDateMax, _minTime, _maxTime;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2 py-4 lg:gap-6 lg:py-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-between",
                                children: category && categoryLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                    href: categoryLink,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "u-body u-body--s text-secondary-500",
                                        children: category
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "u-headline u-headline--h2",
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "u-body u-body--s flex flex-col gap-2 text-typo-secondary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(view_more/* default */.Z, {
                                maxHeight: 70,
                                style: "link",
                                labels: {
                                    viewLess: "Ver menos",
                                    viewMore: "Ver m\xe1s"
                                },
                                children: function(isOpen) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,es/* oneLine */.f9)(ProductDescription_templateObject(), isOpen ? "" : "line-clamp-3"),
                                        dangerouslySetInnerHTML: {
                                            __html: description
                                        }
                                    });
                                }
                            }),
                            (button === null || button === void 0 ? void 0 : button.label) && button.link.url && /*#__PURE__*/ (0,jsx_runtime.jsxs)(next_link/* default */.Z, {
                                href: (0,utils/* removeBaseURL */.t7)((_url = button === null || button === void 0 ? void 0 : button.link.url) !== null && _url !== void 0 ? _url : ""),
                                passHref: true,
                                children: [
                                    "formik",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, (0,_object_spread/* default */.Z)({
                                        label: button === null || button === void 0 ? void 0 : button.label,
                                        negative: button === null || button === void 0 ? void 0 : button.negativo,
                                        as: "a",
                                        style: (ref = button === null || button === void 0 ? void 0 : button.style) !== null && ref !== void 0 ? ref : "primary",
                                        size: button === null || button === void 0 ? void 0 : button.size,
                                        className: "min-w-full md:min-w-fit"
                                    }, (button === null || button === void 0 ? void 0 : button.showIcon) && {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* Info */.k, {})
                                    }))
                                ]
                            })
                        ]
                    })
                ]
            }),
            (customizableBundleOptions === null || customizableBundleOptions === void 0 ? void 0 : customizableBundleOptions.isCustomizable) && /*#__PURE__*/ (0,jsx_runtime.jsx)(bundle_options, {
                onCardAddProduct: customizableBundleOptions.onCardAddProduct
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductForms, {
                type: type,
                bundledItems: bundledItems,
                woosbIds: woosbIds,
                stock: stock,
                template: template,
                price: price,
                productId: productId,
                regularPrice: regularPrice,
                moreInfo: moreInfo,
                isMirakl: isMirakl,
                externalUrl: externalUrl,
                stockAlert: stockAlert,
                attributes: attributes,
                variations: variations,
                isSellerClosed: isSellerClosed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    stock && (0,product/* isOutOfStock */.tS)(stock) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications/* default */.Z, {
                        message: stockAlert ? "Agotado temporalmente" : "Agotado",
                        state: "ERROR",
                        box: false,
                        Icon: Info/* Info */.k
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications/* default */.Z, {
                        message: "La imagen mostrada puede diferir ligeramente del producto real.",
                        state: "INFO",
                        box: false,
                        className: "hidden lg:inline"
                    })
                ]
            }),
            sellerInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(seller_box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                seller: sellerInfo.name,
                sellerLink: isMirakl ? routes.routes.sellers.seller(sellerInfo.slug) : routes.routes.about
            }, brand && {
                brand: brand
            }, (estimateDeliveryDate === null || estimateDeliveryDate === void 0 ? void 0 : estimateDeliveryDate.estimateDeliveryDateMax) || (estimateDeliveryDate === null || estimateDeliveryDate === void 0 ? void 0 : estimateDeliveryDate.estimateDeliveryDateMin) ? {
                deliveryDays: "".concat((_estimateDeliveryDateMin = estimateDeliveryDate.estimateDeliveryDateMin) !== null && _estimateDeliveryDateMin !== void 0 ? _estimateDeliveryDateMin : "", " ").concat(estimateDeliveryDate.estimateDeliveryDateMax && estimateDeliveryDate.estimateDeliveryDateMin ? "-" : "", " ").concat((_estimateDeliveryDateMax = estimateDeliveryDate.estimateDeliveryDateMax) !== null && _estimateDeliveryDateMax !== void 0 ? _estimateDeliveryDateMax : "", " d\xedas laborables")
            } : (0,_object_spread/* default */.Z)({}, ((sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.maxTime) || (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.minTime)) && {
                deliveryDays: "".concat((_minTime = sellerInfo.minTime) !== null && _minTime !== void 0 ? _minTime : "", " ").concat(sellerInfo.minTime && sellerInfo.maxTime ? "-" : "", " ").concat((_maxTime = sellerInfo.maxTime) !== null && _maxTime !== void 0 ? _maxTime : "", " d\xedas laborables")
            }), ((sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.minPrice) || (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.maxPrice)) && {
                deliveryCosts: sellerInfo.minPrice === sellerInfo.maxPrice ? "".concat(sellerInfo.minPrice, " €") : (0,es/* oneLine */.f9)(_templateObject1(), sellerInfo.minPrice ? sellerInfo.minPrice : "", sellerInfo.minPrice && sellerInfo.maxPrice ? "-" : "", sellerInfo.maxPrice ? sellerInfo.maxPrice : "")
            }, sellerInfo.freeShippingAmount && sellerInfo.freeShippingAmount !== "0" && {
                minFreeShipping: "".concat(sellerInfo.freeShippingAmount, " €")
            }), {
                alwaysFree: sellerInfo.alwaysFree || false,
                className: "mt-4",
                children: [
                    isSellerClosed && /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications/* default */.Z, {
                        state: "ERROR",
                        box: true,
                        Icon: Info/* Info */.k,
                        message: "Lo sentimos. Este vendedor no suministra productos desde el ".concat(dateInterval)
                    }),
                    (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.suspended) && /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications/* default */.Z, {
                        state: "ERROR",
                        box: true,
                        Icon: Info/* Info */.k,
                        message: "Lo sentimos. Este vendedor no suministra productos actualmente"
                    })
                ]
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./components/organisms/product-description/index.ts

/* harmony default export */ var product_description = (ProductDescription);


/***/ }),

/***/ 84172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tab; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.js + 1 modules
var tabs = __webpack_require__(49808);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
;// CONCATENATED MODULE: ./components/molecules/tab/header/TabHeader.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        u-actions u-actions--nav relative flex-shrink-0 cursor-pointer pb-1.5 first-of-type:pl-4 last-of-type:pr-4\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var TabHeader = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, title = param.title, children = param.children;
    var arrayOfChildren = (0,utils/* childrenToArray */.QV)(children);
    var list = arrayOfChildren.map(function(child, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab */.O, {
            as: "h2",
            className: function(param) {
                var selected = param.selected;
                return (0,es/* oneLine */.f9)(_templateObject(), selected ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-1 after:bg-[url(\"/assets/images/underline.svg\")] after:bg-bottom after:bg-no-repeat after:content-['']" : "");
            },
            children: child
        }, index);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative before:absolute before:left-4 before:right-4 before:top-0 before:h-px before:border-t before:border-dashed before:border-primary-900 before:content-[''] after:absolute after:bottom-0 after:left-4 after:right-4 after:hidden after:h-px after:border-b after:border-dashed after:border-primary-900 after:content-[''] md:px-4 after:md:block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative -mx-4 flex items-center gap-16 px-4 py-2 md:overflow-x-auto md:px-0 min-[1160px]:mx-0 xl:gap-32 ".concat(className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "u-headline u-headline@mobile--h2 hidden border-r border-primary-900 py-2 pl-4 pr-6 md:inline-block min-[1160px]:pl-0",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.List */.O.List, {
                    className: "flex items-center gap-10 overflow-x-scroll pb-2 pt-3 md:overflow-x-visible",
                    children: list
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/tab/header/index.ts

/* harmony default export */ var tab_header = (TabHeader);

;// CONCATENATED MODULE: ./components/molecules/tab/body/TabBody.tsx



var TabBody = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, children = param.children;
    var arrayOfChildren = (0,utils/* childrenToArray */.QV)(children);
    var panels = arrayOfChildren.map(function(child, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.Panel */.O.Panel, {
            unmount: false,
            children: child
        }, index);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.Panels */.O.Panels, {
        className: "px-4 ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "border-b border-dashed border-primary-600 py-3 xs:py-10",
            children: panels
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/tab/body/index.ts

/* harmony default export */ var tab_body = (TabBody);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./lib/utils/collections.tsx
var collections = __webpack_require__(27377);
;// CONCATENATED MODULE: ./components/organisms/tab/Tab.tsx





var Tab = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)((0,collections/* pickChild */.xC)(children, tab_header), 2), header = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,collections/* pickChild */.xC)(children, tab_body), 2), body = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "-mx-4 ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* Tab.Group */.O.Group, {
            children: [
                header,
                body
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/organisms/tab/index.ts


Tab.Header = tab_header;
Tab.Body = tab_body;
tab_header.displayName = "Tab.Header";
tab_body.displayName = "Tab.Body";
/* harmony default export */ var tab = (Tab);


/***/ })

}]);